module.exports = __webpack_public_path__ + "img/fudongzuo.prt.8adf3730.jpg";